import React, { useEffect, useState } from "react"

type Props = {
    src: string,
    className: string,
    /** Nom affiché en initiales quand l'image manque ou ne charge pas */
    name?: string,
}

const initialsOf = (name?: string) =>
    (name || '')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase())
        .join('')

export const Avatar = ({
    src,
    className = 'w-10 h-10 rounded-full',
    name,
}: Props) => {

    const [failed, setFailed] = useState(!src)

    useEffect(() => {
        setFailed(!src)
    }, [src])

    if (failed) {
        const initials = initialsOf(name)
        return (
            <div
                aria-hidden="true"
                className={`flex-none flex items-center justify-center overflow-hidden bg-gradient-to-br from-brand-300 to-brand-600 text-white font-semibold text-[0.7em] ${className}`}
            >
                {initials || (
                    <svg viewBox="0 0 24 24" className="w-1/2 h-1/2 fill-white/90">
                        <path d="M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0 2.25c-3.6 0-7.5 1.8-7.5 4.5V21h15v-2.25c0-2.7-3.9-4.5-7.5-4.5Z" />
                    </svg>
                )}
            </div>
        )
    }

    return (
        <img
            src={src}
            alt=""
            onError={() => setFailed(true)}
            className={`flex-none object-cover ${className}`}
        />
    )
}
